import Component from '../../component.abstract'
import {getLocationAttribute} from "../../helpers/location";
import {getAjax} from "../../helpers/http";
import {getOffset} from "../../helpers/html-utils";
import {hw} from "../../helpers/paths";
import {initialiseComponents} from "../../../core"
import { AutocompleteField } from '../../binder/binder-autocomplete';
import { getItemFromLocalStorage, setItemInLocalStorage } from '@utils/local_storage/local_storage.utils';

interface SuggestInputProps {
    name?: string,
    limit?: number,
    minLength?: number,
    delay?: number,
    url?: string,
    term?: string,
    type?: string,
    mandatory?: boolean,
    merge?: boolean,
    norecent?: boolean,
    displayBelow?: boolean,
    displayMessage?: boolean,
    class?: string,
    innerClass?: string,
    suggestionsClass?: string,
    initShortId?: string,
    inTunnel?: boolean
}

/**
 * Autocomplete component
 * A nightmare created while on drugs
 */
export default class SuggestInput extends Component {
    private readonly props:SuggestInputProps = {
        limit: Infinity,
        minLength: 3,
        delay: 300,
        term: 'term',
        mandatory: false,
        merge: false,
        displayBelow: false
    }
    public valid = false
    private uri = false
    private focused = false
    public name:string
    private wtrecent:boolean
    public mandatory:boolean
    private mandatoryMessage:HTMLElement
    private errorMessage:string | boolean
    private initValue:string
    private initShortId: string
    private option:string
    private oldValue:string
    public autocompleteinput:HTMLInputElement
    private highlightedIndex: number
    private highlightable: any[]
    private highlightableOption: any[]
    private placeHolder: any;
    public innerInput: any;
    private choices: any;
    private clicked: boolean;
    private displayBelow: any;
    private belowUl: HTMLUListElement;
    private retest: any;
    private wrapperInput: HTMLDivElement;
    private keyUp: any;
    private value: string;
    private forceNoBlur: boolean;
    private _timer: any;
    private inTunnel: boolean;

    constructor(
        props:SuggestInputProps,
        element:HTMLElement
    ) {
        super(props, element)
        this.props = Object.assign(this.props, props)
    }

    /**
     * set template and events
     */
    mounted ():void {
        if (this.element.hasAttribute('readonly')) {
            return;
        }

        this.name = this.props.name ?? this.element.getAttribute("name") ?? ''
        this.wtrecent = !this.props.norecent
        this.mandatory = this.props.mandatory

        if (document.querySelector('[data-funnel]') ||
            document.querySelector('[data-lp-form]')) {
            this.mandatory = true
            this.uri = true
        }

        if (this.mandatory && typeof this.props.displayMessage !== 'undefined') {
            // First, we try to select an element that has the same parent as the element we are bound to
            this.mandatoryMessage = this.element.parentElement.querySelector(`[data-valmsg-for=${this.name}]`)
            if(!this.mandatoryMessage) {
                // If this doesn't work, try to select an element anywhere in the page
                this.mandatoryMessage = document.querySelector(`[data-valmsg-for=${this.name}]`)
            }
            this.errorMessage = this.props.displayMessage === true ? 'Veuillez remplir ce champ.' : this.props.displayMessage
        }

        // Display multiple value below the input
        this.displayBelow = this.props.displayBelow ?? false;
        this.belowUl;

        // try to get the default value of the input field
        this.initValue = this.element.getAttribute('value')
        this.initShortId = this.props.initShortId

        // once the specific values are laoeded try to init the element
        if (this.props.url !== '' || this.name !== '') {
            this.init();
        }

        this.option = '';

        this.inTunnel = this.props.inTunnel ?? document.querySelector('.tunnel') !== null;
    }
    /**
     * Init
     */
    init () {
        this.oldValue = ''
        this.autocompleteinput = document.createElement('input')
        this.highlightedIndex = -1;
        this.highlightable = [];
        this.highlightableOption = [];
        this.clicked = false;
        this.element.classList.add("js-enabled")

        const wrapper = this.generate();
        this.element.parentNode.insertBefore(wrapper, this.element.nextSibling);

        this.autocompleteinput.setAttribute("type", "text");
        this.element.parentNode.insertBefore(this.autocompleteinput, wrapper.nextSibling);

        if (this.initValue && !this.displayBelow) {
          this.innerInput.value = this.initValue;
          this.autocompleteinput.setAttribute("value", this.initValue);
        }

        if (this.initShortId && this.initShortId !== "") {
            this.autocompleteinput.setAttribute("value", this.initShortId);
        }
        if (this.name) {
            this.autocompleteinput.setAttribute('name', `${this.name}_autocomplete`)
            const autocompleteAttr = getLocationAttribute(`${this.name}_autocomplete`)
            if (autocompleteAttr) {
                this.autocompleteinput.setAttribute('value', autocompleteAttr)
            }
        }

        if (this.displayBelow) {
            this.belowUl = document.createElement("ul");
            this.belowUl.classList.add('multitags')
            this.belowUl.setAttribute("data-autocomplete-tags", this.name);
            this.element.parentNode.appendChild(this.belowUl);
            this.element.setAttribute("name", this.name + "-notused")
            if (this.initValue && typeof JSON.parse(this.initValue) === "object") {
              this.addTag(JSON.parse(this.initValue));
            }
        }

        this.element.addEventListener('change', () => this.toggleBind())

        if(this.element.getAttribute("name") != "k") {
            this.innerInput.setAttribute("placeholder", this.element.getAttribute("placeholder"));
        } else {
            const placeholder = this.element.getAttribute("data-placeholder");

            if (placeholder !== null) {
                const placeholderArray = placeholder.split(",");

                if(placeholderArray.length > 1) {
                    const $timing = 0;
                    let j: any;
                    this.retest = setInterval(() => this.changePlaceholder(placeholderArray, j, $timing), 2000);
                } else {
                    this.innerInput.setAttribute("placeholder", this.element.getAttribute("placeholder"));
                }
            } else {
                this.innerInput.setAttribute("placeholder", this.element.getAttribute("placeholder"));
            }
        }

        initialiseComponents()
    }

    changePlaceholder(placeholderArray: string | any[], j: number, $timing: number) {
        let placeh;
        const txt = "Essayez avec : ";
        const max = placeholderArray.length - 1;
        let i = this.getRandomIntInclusive(0, max);

        if (i !== j) {
            placeh = txt + placeholderArray[i];
            this.innerInput.setAttribute("placeholder", placeh);
            j = i;
        } else {
            if(j < max) {
                i = j + 1;
            } else {
                i = j - 1;
            }
            j = i;
            placeh = txt + placeholderArray[i];
            this.innerInput.setAttribute("placeholder", placeh);
        }

        $timing++;

        if ($timing > 60) {
            clearInterval(this.retest);
            let placeholderfinal = "";

            for(let z=0; z < placeholderArray.length; z++) {
                if(z == (placeholderArray.length - 1)) {
                    placeholderfinal += placeholderArray[z];
                } else {
                    placeholderfinal += placeholderArray[z] + ", ";
                }

            }
            this.innerInput.setAttribute("placeholder", placeholderfinal);
        }
    }

    getRandomIntInclusive(min: number, max: number) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min +1)) + min;
    }

    generate ():HTMLDivElement {
        const svghelper = "http://www.w3.org/2000/svg";
        this.wrapperInput = document.createElement("div");
        if (this.props.class) {
            this.wrapperInput.classList.add(...this.props.class.split(" "));
        }
        this.placeHolder = document.createElement("div");
        this.innerInput = document.createElement("input");
        this.innerInput.setAttribute("type", "text");
        this.innerInput.setAttribute("autocomplete", "chrome-autocomplete-disabled");
        this.innerInput.setAttribute("placeholder", this.element.getAttribute("placeholder"));
        this.innerInput.setAttribute("data-autocomplete-input-name", this.name)
        this.innerInput.classList.add(...["autocomplete-innerinput-" + this.name, "tw-outline-none"])
        if (this.props.innerClass) {
            this.innerInput.classList.add(...this.props.innerClass.split(" "));
        }

        
        this.choices = document.createElement("ul");
        if (this.props.suggestionsClass) {
            this.choices.classList.add(...this.props.suggestionsClass.split(" "));
        }

        this.wrapperInput.appendChild(this.placeHolder);
        this.wrapperInput.appendChild(this.innerInput);

        const cross = document.createElement("span");
        const svgCross = document.createElementNS(svghelper, "svg");
        svgCross.setAttribute("data-controller", "cross-origin-svg");
        svgCross.setAttribute("data-cross-origin-svg-url-value", hw.getBaseRessourcesUrl() + "/img/svg/close0.svg");

        cross.setAttribute("class", "cross-input");
        cross.appendChild(svgCross);

        this.wrapperInput.appendChild(cross);
        cross.addEventListener("click", (e) => {
            this.clear();
            if (window.innerWidth < 767) {
                if(document.querySelectorAll("[data-engine-s-facets]>input[type=checkbox]:checked").length > 0) {
                    this.focus();
                }

            } else {
                this.focus();
            }
        });

        this.wrapperInput.appendChild(this.choices);
        this.wrapperInput.addEventListener("keydown",e => this.highlightOr(e));
        this.wrapperInput.addEventListener("keyup",e => this.orCall(e));

        if (window.innerWidth < 767 && this.element.getAttribute('name') === 'k') {
            this.wrapperInput.addEventListener("keyup", e => {
                if (this.keyUp) {
                    clearTimeout(this.keyUp);
                }

                this.keyUp = setTimeout(() => this.detectNext(e), 500);
            });
        }

        if (this.inTunnel && window.innerWidth < 767) {
            document.querySelector('.whereinput label')
                .addEventListener("click", e=> {
                e.stopImmediatePropagation();

                document
                    .querySelector('[name="l"]')
                    .nextElementSibling
                    .querySelector('input')
                    .focus();

                setTimeout(() => {
                    window.scrollTo({
                        top : 100,
                        behavior : "smooth"
                    });
                }, 300)
            })

            document.querySelector('.whatinput label').addEventListener("click", e => {
                document
                    .querySelector('[name="k"]')
                    .nextElementSibling
                    .querySelector('input')
                    .focus();

                setTimeout(() => {
                    window.scrollTo({
                        top : 40,
                        behavior : "smooth"
                    });
                }, 300)
            })
        }

        this.innerInput.addEventListener('focus', () => {
            (<HTMLElement> this.element.parentNode).classList.add('activ');
            this.wrapperInput.classList.add('focused');
            this.element.dispatchEvent(new CustomEvent("focus"))
            this.call();
            PubSub.publish("suggestInput.focus", this)

            if (this.inTunnel && window.innerWidth < 767){
                if (this.element.getAttribute("name") == "l" && window.scrollY != 100) {
                    setTimeout(() => {
                        window.scrollTo({
                            top : 100,
                            behavior : "smooth"
                        });
                    }, 350)
                } else if (this.element.getAttribute("name") == "k" && window.scrollY != 40) {
                    setTimeout(() => {
                        window.scrollTo({
                            top : 40,
                            behavior : "smooth"
                        });
                    }, 350)
                }
            }
        })

        this.innerInput.addEventListener("focus", () => this.wrapperInput.classList.add("focused"))
        this.innerInput.addEventListener("blur", (event: any) => {
            (<HTMLElement> this.element.parentNode).classList.remove('activ');
            this.element.dispatchEvent(new CustomEvent("blur"))
            if(!document.querySelector('#enginechat')) {
                this.wrapperInput.classList.remove('focused');
            }

            if (this.props.type === 'position') {
                this.element.classList.remove('activ');
            }

            if (this.mandatory) {
                if(!this.valid) {
                    event.target.value = "";
                } else {
                    this.valid = false;
                }

                this.check();
            }

            //show cta in tunnel mobile
            if(this.inTunnel && window.innerWidth < 767) {
                (<HTMLElement> document.querySelector('.cta')).style.display = "block";

                // => serp (cta slecteur différent !!)
                if (document.querySelector('[data-facets].side') && document.querySelector('.tunnel [data-reload]')) {
                    (<HTMLElement> document.querySelector('.tunnel [data-reload]')).style.display = "block";
                }

                setTimeout(() => {
                    if (this.clicked) {
                        this.clicked = false
                    } else {
                        this.blurIt(event)
                    }
                },400)
            }

            PubSub.publish("suggestInput.blur", this)
        })

        if (this.inTunnel && this.element.getAttribute('name') === 'l')  {
            if((<HTMLInputElement> this.element).value) {
                //cas de RJ qui n'a pas de champs distance
                if (document.querySelector('.distance')) {
                    document.querySelector('.distance').classList.add('show');
                }
            }
        }

        this.innerInput.addEventListener('change', () => {
            this.element.dispatchEvent(new CustomEvent("change"))
            const distance = document.querySelector('.distance')

            if (this.value === '') {
                this.valid = false;
            }

            //cas de RJ qui n'a pas de champs distance
            if (this.element.getAttribute('name') === 'l' &&
                this.inTunnel &&
                distance
            ) {
                this.value !== '' ? distance.classList.add('show') : distance.classList.remove('show')
            }
            PubSub.publish("suggest-change", this)
        })

        // when a click is triggered outside the dropdown, this one should collapse
        window.addEventListener("click", event => this.blurIt(event))

        this.element.addEventListener('focus', () => {
            this.focused = true;
            this.forceNoBlur = true;
            setTimeout(() => {
                this.forceNoBlur = false;
            }, 2000);
        })

        return this.wrapperInput;
    }

    focus () {
        (<HTMLElement> this.element.parentNode).classList.add('activ');
        this.innerInput.focus();
    }

    getCookieValue (cookieName: string) {
        const cookie = getItemFromLocalStorage(cookieName);
        if(cookie !== null) {
            const cookieValue = getItemFromLocalStorage(cookieName).replace(/[=]+/g, '');
            try {
                return JSON.parse(cookieValue);
            } catch (e) {
                // pass
            }
        }
        return [];
    }

    getRecents (merge?: boolean) {
        let cookieName

        if (this.name && this.wtrecent) {
            cookieName = `${this.name}_autocomplete`
        } else if (this.props.merge || merge) {
            cookieName = 'merge_autocomplete'
        }

        return this.getCookieValue(cookieName)
    }

    highlightOr (e:KeyboardEvent) {
        if (window.innerWidth < 767) {
            if([13, 9].includes(e.keyCode) && this.element.getAttribute('name') === 'k') {
                e.preventDefault();

                while(this.choices.firstChild){
                    this.choices.removeChild(this.choices.firstChild);
                }

                if(this.getRecents().length > 0) {
                    this.removeRecent();
                }

                this.highlight(e);
            }
        } else {
            if (this.highlightedIndex > -1) {
                if ([13, 37, 38, 39, 40].includes(e.keyCode)) {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                    }
                    this.highlight(e);
                } else {
                    this.highlightedIndex = -1;
                }
            } else if ([37, 38, 39, 40].includes(e.keyCode)) {
                this.highlight(e);
            }
        }
    }

    orCall (e: KeyboardEvent) {
        if (this.highlightedIndex > -1) {
            if ((e.keyCode == 13 && this.element.getAttribute("name") != "k" && window.innerWidth < 767) ||  e.keyCode == 13) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.validate();
            }
        } else {
            if (![13, 9, 37, 38, 39, 40].includes(e.keyCode) && this.innerInput.value !== this.oldValue) {
                this.call(e);
            }
        }
    }

    detectNext (e: KeyboardEvent) {
        if([9, 13, 229].includes(e.keyCode) && this.innerInput.value === this.oldValue) {
            if (this.getRecents().length > 0) {
                this.removeRecent();
            }

            while (this.choices.firstChild) {
                this.choices.removeChild(this.choices.firstChild);
            }

            e.preventDefault();
        } else {
            this.oldValue = this.innerInput.value;
        }
    }

    call (e?: KeyboardEvent) {
        const term = e ? (<HTMLInputElement> e.target).value : (<HTMLInputElement> this.element).value;
        (<HTMLInputElement> this.element).value = term;
        this.autocompleteinput.value = '';

        if (term.length >= this.props.minLength) {
            if (this._timer){
                clearTimeout(this._timer);
            }

            this._timer = setTimeout(() => {
                const delimiter = this.props.url.indexOf('?') > -1 ? '&' : '?';
                const request:any = {};
                request.url = `${this.props.url}${delimiter}${this.props.term}=${term}`;
                request.success = (data: any) => {
                    this.populate(data, term)
                    initialiseComponents();
                }
                getAjax(request);
            }, this.props.delay);
        } else {
            this.populate('[]', term);
            initialiseComponents();
        }

        if(this.inTunnel && window.innerWidth < 767){
            document.querySelector(".tunnel").addEventListener('keydown', (event:KeyboardEvent) => {
                if(event.keyCode === 13) {
                    event.stopImmediatePropagation();

                    while (this.choices.firstChild) {
                        this.choices.removeChild(this.choices.firstChild);
                    }

                    const ctaElement:HTMLElement = document.querySelector('.cta')
                    const sidefacetsElement:HTMLElement = document.querySelector('[data-facets].side')
                    const reloadElement:HTMLElement = document.querySelector('.tunnel [data-reload]')
                    const lElement:HTMLInputElement = document.querySelector('[name="l"]')
                    const kElement:HTMLInputElement = document.querySelector('[name="k"]')
                    const engineElement:HTMLFormElement = <HTMLFormElement> document.getElementById('engine')

                    ctaElement.style.display = 'block';

                    if (sidefacetsElement) {
                        if (reloadElement) { // => serp (cta slecteur différent !!)
                            reloadElement.style.display = 'block'
                        }
                    }

                    // test both input
                    if(lElement.value !== '' && kElement.value !== '') {
                        engineElement.submit();
                    }
                }
            });
        }
    }

    highlight (e: KeyboardEvent) {
        const oldIndex = this.highlightedIndex;
        if (this.highlightedIndex === -1) {
            if (this.highlightable.length > 0) {
                this.highlightedIndex = 0;
            }
        } else {
            switch(e.keyCode) {
                case 37 : break;
                case 38 : this.highlightedIndex > 0 ? this.highlightedIndex-- : true; break;
                case 39 : break;
                case 40 : this.highlightedIndex < this.highlightable.length - 1 ? this.highlightedIndex++ : true; break;
            }
        }
        if (oldIndex != this.highlightedIndex) {
            if (oldIndex != -1) {
                let olel = this.highlightable[oldIndex];

                if (olel.nodeName != 'LI') {
                    olel = olel.parentNode;
                }
                olel.classList.remove('highlight');
            }
            let el = this.highlightable[this.highlightedIndex];

            if (el.nodeName != 'LI') {
                el = el.parentNode;
            }
            el.classList.add('highlight');
        }
    }

    validate () {
        if (this.highlightedIndex !== -1 && this.highlightedIndex < this.highlightable.length) {
            this.selectAuto(this.highlightableOption[this.highlightedIndex])
            this.highlightedIndex = -1
        }
    }

    cleanData (data: any) {
        let result = data;

        if (this.props.type === 'position') {
            result = result.split('(');
            result.shift();
            result = result.join('(');
            result = result.substring(0, result.length - 2)
        }

        return result;
    }

    cleanChoices () {
        while(this.choices.firstChild){
            this.choices.removeChild(this.choices.firstChild);
            this.choices.length;
        }
    }

    optionsFromData (data: string) {
        if (data !== '') {
            const options = JSON.parse(data);

            if (this.props.type === 'position') {
                const filter:any = {
                    latitudeMax: 49.74761,
                    latitudeMin: 48.1495,
                    longitudeMax: 3.55507,
                    longitudeMin: 1.38124
                };

                return options.results.items.filter((option:any) => {
                    const latitude = option.position[0];
                    const longitude = option.position[1];

                    return (
                        latitude >= filter.latitudeMin &&
                        latitude <= filter.latitudeMax &&
                        longitude <= filter.longitudeMax &&
                        longitude >= filter.longitudeMin
                    )
                })
            }
            return options;
        } else {
            return [];
        }
    }

    addLi (optval: string, input: string, option:any, recent?: boolean) {
        if (recent && this.props.type === 'super') {
            optval = option.Value;
        }

        if (optval) {
            optval = optval.trim().toLowerCase();
            if(option.where && option.where.value){
                optval += " - " + option.where.value.trim().toLowerCase();
            }
            const tokens = optval.split(input);
            const li = document.createElement("li");

            const spanOpt = document.createElement("span");
            const spanClear = document.createElement("span");

            for (let j = 0; j < tokens.length - 1; j++) {
                const value = document.createTextNode(tokens[j]);
                spanOpt.appendChild(value);

                const strong = document.createElement("strong");
                const inp = document.createTextNode(input);
                strong.appendChild(inp);
                spanOpt.appendChild(strong);
            }

            const strongu = document.createElement("span");
            const valueu = document.createTextNode(tokens[tokens.length - 1]);
            strongu.appendChild(valueu);
            spanOpt.appendChild(strongu);
            li.appendChild(spanOpt);
            if (recent) {
                 const svghelper = "http://www.w3.org/2000/svg";
                const svgCross = document.createElementNS(svghelper, "svg");
                svgCross.setAttribute("data-controller", "cross-origin-svg");
                svgCross.setAttribute("data-cross-origin-svg-url-value", hw.getBaseRessourcesUrl() + "/img/svg/close0.svg");
                spanClear.appendChild(svgCross);
                li.appendChild(spanClear);
                li.classList.add("recent");
                this.setClearEvent(spanClear, option);
            }


            this.choices.appendChild(li);
            this.setLiEvent(spanOpt, option);
            this.highlightable.push(li);
            this.highlightableOption.push(option);
            return li;
        }
    }

    willPopulateRecnts () {
        const recents = this.getRecents();
        return recents.length !== 0 && this.props.type !== 'position' ? recents : []
    }

    populateRecents (input: string) {
        const recents = this.getRecents();

        if (recents.length > 0 && this.props.type !== 'position') {
            const li = document.createElement('li');
            const spanOpt = document.createElement('span');
            const recentCount = recents.length;
            const $plural = recentCount > 1 ? 's' : '';
            const alls = document.createTextNode(`${recentCount} recherche${$plural} récente${$plural}`);
            const spanpicto = document.createElement("span");
            let spanClear;

            li.classList.add('recent');
            li.classList.add('all');
            spanpicto.classList.add('picto-up-grey');
            spanOpt.appendChild(alls);
            spanOpt.appendChild(spanpicto);

            if (recents.length > 1) {
                const cross = document.createTextNode('Tout effacer');
                spanClear = document.createElement('span');
                spanClear.appendChild(cross);
                spanClear.addEventListener('click', () => this.removeRecent())
            }

            spanOpt.addEventListener('click', (event:MouseEvent) =>  {
                const lirecent = document.querySelectorAll('.recent:not(.all)');
                event.stopImmediatePropagation();
                this.clicked = true;

                lirecent.forEach((item:Element) => item.classList.toggle('hide'))
                spanpicto.classList.toggle('down');
            })

            li.appendChild(spanOpt)

            if (spanClear) {
                li.appendChild(spanClear);
            }

            this.choices.appendChild(li);

            for (let i = 0; i < recents.length && i < 10; i++) {
                this.addLi(recents[i].value, input, recents[i], true);
            }

            return recents;
        } else {
            return [];
        }
    }

    populateOptions (options: any[], input: string) {
        if (options.length !== 0) {

            options.forEach((option) => {
                let optval = option.value;

                if (this.props.type === 'position') {
                    const regex1 = new RegExp('<br/>', 'gi')
                    const vicinity = option.vicinity.replace(regex1, ', ')

                    optval = `${option.title}, ${vicinity}`
                }

                if (this.props.type === 'super') {
                    optval = option.Value;
                }

                const lu = this.addLi(optval, input, option);

                if (lu && this.props.type === 'super') {
                    lu.classList.add('super');
                    option.options.forEach((subOption:any) => this.addLi(subOption.Value, input, subOption))
                }
            })

            if (this.props.type === 'position') {
                this.element.classList.add('activ');
            }
        }
    }

    getOptionsWithoutRecents (options: any[], recents: any[]) {
        if (recents.length === 0) {
            return options;
        } else {
            return options.filter((option) => (
                (this.props.type === 'super' && !recents.every(recent => recent.Value === option.Value)) ||
                !recents.every(recent => recent.value === option.value)
            ))
        }
    }

    getOptionsToUse (recents: any[], withoutRecents: any[]) {
        const optionstoUse = [];

        for (let zo = recents.length; zo < 10 && zo - recents.length < withoutRecents.length; zo++) {
            if (withoutRecents[zo - recents.length]) {
                optionstoUse.push(withoutRecents[zo - recents.length]);
            }
        }

        return optionstoUse;
    }

    getValue (alias?: any) {
        const result:any = {};

        result[alias || this.name] = this.innerInput.value;
        result[`${alias || this.name}_autocomplete`] = this.autocompleteinput.value;

        return result;
    }

    sortOptions (options: any[]) {
        let sortedOptions;

        if (this.props.type === 'super') {
            sortedOptions = [];
            const supercat = [];

            for (let fo = 0; fo < options.length; fo++) {
                if (supercat.indexOf(options[fo].SuperValue) < 0) {
                    supercat.push(options[fo].SuperValue);

                    sortedOptions.push({
                        'Value': options[fo].SuperValue,
                        "id": options[fo].Uri,
                        'options': []
                    });
                }

                sortedOptions[supercat.indexOf(options[fo].SuperValue)].options.push(options[fo]);
            }
        }

        return sortedOptions || options;
    }

    populate (data: string, input: string) {
        data = this.cleanData(data);
        this.cleanChoices();
        this.highlightable = [];
        this.highlightableOption = [];
        this.highlightedIndex = -1;
        const options = this.optionsFromData(data);
        input = input.trim().toLowerCase();

        //hide cta in tunnel mobile
        if(this.inTunnel && window.innerWidth < 767){
            (<HTMLElement> document.querySelector('.cta')).style.display = "none";
            if(document.querySelector('[data-facets].side')) {
                // => serp (cta slecteur différent !!)
                if(document.querySelector('.tunnel [data-reload]')) {
                    (<HTMLElement> document.querySelector('.tunnel [data-reload]')).style.display = "none";
                }
            }
        }

        const recents = this.willPopulateRecnts();
        const allWithoutRecent = this.getOptionsWithoutRecents(options, recents);
        const optionstoUse = this.sortOptions(this.getOptionsToUse(recents, allWithoutRecent));
        if (optionstoUse.length > 0) {
            this.populateOptions(optionstoUse, input);
        }
        if (recents.length > 0) {
            this.populateRecents(input);
        }
    }

    setLiEvent (li: HTMLSpanElement, option: any) {
        li.addEventListener("click", (e:MouseEvent) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            this.clicked = true;
            this.option = option;
            this.selectAuto(option, this.mandatory)
            this.innerInput.blur();

            if(this.inTunnel && window.innerWidth < 767){
                if(this.element.getAttribute('name') === "k") {

                    if((<HTMLInputElement> document.querySelector('[name="l"]')).value === "") {
                        document.querySelector('[name="l"]').nextElementSibling.querySelector('input').focus();
                        setTimeout(() => {
                            window.scrollTo({
                                top : 100,
                                behavior : "smooth"
                            });
                        }, 300)
                    }
                } else if(this.element.getAttribute('name') === "l") {
                    if((<HTMLInputElement> document.querySelector('[name="k"]')).value === "") {
                        document.querySelector('[name="k"]').nextElementSibling.querySelector('input').focus();
                        setTimeout(() => {
                            window.scrollTo({
                                top : 40,
                                behavior : "smooth"
                            });
                        }, 300)
                    }
                }
            }

            PubSub.publish("autocomplete-change", this)
        });
    }

    setClearEvent (li: HTMLSpanElement, option: any) {
        li.addEventListener('click', (e) => this.removeRecent(option))
    }

    selectAuto (option:any, keep?: boolean) {
        while (this.choices.firstChild) {
            this.choices.removeChild(this.choices.firstChild)
        }

        if (keep !== true) {
            this.clear();
        }

        if (this.props.type === 'position') {
            const regex1 = new RegExp("<br/>", "gi");
            const vicinity = option.vicinity.replace(regex1, ", ");

            (<HTMLInputElement> this.element).value = "{\"gps\" : \"" + option.position[0] + ", " + option.position[1] + "\", \"adresse\" : \"" + option.title + ", " + vicinity + "\"}";
            this.autocompleteinput.value = option.title + ", " + vicinity;
            this.innerInput.value = option.title + ", " + vicinity;
        } else {
            switch(this.props.type) {
                case "super":
                    (<HTMLInputElement> this.element).value = option.Value;
                    this.autocompleteinput.value = option?.Job?.Uri || option.Uri || option.id;
                    this.innerInput.value = option.Value;
                    break;

                case "address":
                    (<HTMLInputElement> this.element).value = option.street;
                    this.autocompleteinput.value = JSON.stringify(option);
                    this.innerInput.value = option.street;
                    break;

                default:
                    (<HTMLInputElement> this.element).value = option.value;
                    this.autocompleteinput.value = option.id;
                    this.innerInput.value = option.value;
            }

            this.saveRecent(option);
        }

        this.valid = true;
        if (this.mandatoryMessage) {
            this.check();
        }

        if(
            this.element.getAttribute('name') === 'l' &&
            this.inTunnel &&
            document.querySelector('.distance')
        ) {
            document.querySelector('.distance').classList.add('show');
        }

        if (this.uri) {
            if (option.Job) {
                if(!document.querySelector('.data-job-id')) {
                    const inputjobdata = document.createElement('input');
                    inputjobdata.setAttribute('type', 'hidden');
                    inputjobdata.classList.add('data-job-id');
                    inputjobdata.value = option.Job.ShortId;
                    this.element.parentNode.appendChild(inputjobdata)
                } else {
                    (<HTMLInputElement> document.querySelector('.data-job-id')).value = option.Job.ShortId;
                }
            }

            if (option.shortId && !option.Job) {
                if(!document.querySelector('.data-loc-id')) {
                    const inputlocdata = document.createElement('input');
                    inputlocdata.setAttribute('type', 'hidden');
                    inputlocdata.classList.add('data-loc-id');
                    inputlocdata.value = option.shortId;
                    this.element.parentNode.appendChild(inputlocdata)
                } else {
                    (<HTMLInputElement> document.querySelector('.data-loc-id')).value = option.shortId;
                }
            }
        }
        if (window.innerWidth > 767) {
            // TODO REFACTO
            // hw.callEngine = false;
        } else {
            //show cta in tunnel mobile
            if(this.inTunnel) {
                (<HTMLElement> document.querySelector('.cta')).style.display = 'block';
                if(document.querySelector('[data-facets].side')) {
                    // => serp (cta slecteur différent !!)
                    if(document.querySelector('.tunnel [data-reload]')) {
                        (<HTMLElement> document.querySelector('.tunnel [data-reload]')).style.display = "block";
                    }
                }
            }
        }
        this.wrapperInput.classList.remove("focused");

        if (this.displayBelow) {
            // Check tag unicity
            const existingTag = this.belowUl.querySelector('[value="' + option.id + '"]');
            if (!existingTag) {
                this.addTag(option);
            } else {
                this.clearInput();
            }
        }
    }

    addTag(option:any):void {
        // Create list element
        const li = document.createElement("li");
        const span = document.createElement("span");
        span.innerText = option.value || option.Value;

        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", this.name);

        // Carefull id is needed for /jobalerte input "Villes" because back need short uri which is in option.id
        input.value = option.id;

        if (this.props.type === "super" && option.Job) {
            // In case of hierarchical items (category + job), we need to get id inside the Job property
            input.value = option.Job.Uri;
        }

        const svghelper = "http://www.w3.org/2000/svg";
        const svg: unknown = document.createElementNS(svghelper, "svg");
        const svgElement: HTMLElement = <HTMLElement>svg;
        svgElement.setAttribute("data-controller", "cross-origin-svg");
        svgElement.setAttribute("data-cross-origin-svg-url-value", hw.getBaseRessourcesUrl() + "/img/svg/close0.svg");

        // Inject the SVG into the DOM

        // Add the list element
        li.appendChild(span);
        li.appendChild(input);
        li.appendChild(svgElement);

        this.belowUl.appendChild(li);
        initialiseComponents();
      
        this.clearInput();
        this.toggleDisabledIfLimitMax()
        // Add handler on close icon
        svgElement.addEventListener("click", () => {
            svgElement.parentElement.remove();
            PubSub.publish("suggestInput.removeTag", this);
            this.toggleDisabledIfLimitMax()
        });

        PubSub.publish("suggestInput.addTag", this);
    }

    toggleDisabledIfLimitMax(): void {
        this.innerInput.disabled = this.getCriterionFormatValues().length >= this.props.limit
    }

    clearInput(): void {
        (<HTMLInputElement>this.element).value = "";
        this.innerInput.value = "";
    }

    saveRecent (option: any) {
        if (this.name) {
            const recents = this.getRecents();
            switch(recents.length) {
                case 0 :
                    recents.push(option);
                    break;
                default :
                    var alreadyRecent = false;
                    if (this.props.type === "position") {
                        alreadyRecent = recents[0].title == option.title && recents[0].vicinity == option.vicinity;
                    } else if(this.props.type === "super") {
                        alreadyRecent = recents[0].Value == option.Value;
                    } else {
                        alreadyRecent = recents[0].value == option.value;
                    }
                    if (!alreadyRecent) {
                        while (recents.length > 1) {
                            recents.pop();
                        }
                        recents.push(recents[0]);
                        recents[0] = option;
                    }
                    break;
            }
            setItemInLocalStorage(this.name.replace(/[\=&]+/g, '') + "_autocomplete", JSON.stringify(recents));
        }
    }

    saveRecentMerge (option:any){
        const recents = this.getRecents(true);
        switch(recents.length) {
            case 0 :
                recents.push(option);
                break;
            default :
                var alreadyRecent = false;
                if (this.props.type == "position") {
                    alreadyRecent = recents[0].title == option.title && recents[0].vicinity == option.vicinity;
                } else if(this.props.type == "super") {
                    alreadyRecent = recents[0].Value == option.Value && recents[0].where.value == option.where.value;
                } else {
                    alreadyRecent = recents[0].value == option.value && recents[0].where.value == option.where.value;
                }
                if (!alreadyRecent) {
                    while (recents.length > 5) {
                        recents.pop();
                    }
                    recents.push(recents[0]);
                    recents[0] = option;
                }
                break;
        }
        setItemInLocalStorage("merge_autocomplete", JSON.stringify(recents));
    }

    isAlreadyRecent (recent:any, option:any)  {
        if (this.props.type === 'position') {
            return (
                recent.title === option.title &&
                recent.vicinity === option.vicinity
            );
        } else if (this.props.type === 'super') {
            return recent.Value === option.Value;
        } else {
            return recent.value === option.value;
        }
    }

    removeRecent (option?:any) {
        if (this.name) {
            const recents = option ? this.getRecents() : [];

            if (recents.length !== 0) {
                if (recents.length === 5 && this.isAlreadyRecent(recents[4], option)) {
                    recents.pop();
                }

                if (this.isAlreadyRecent(recents[0], option)) {
                    recents.shift();
                }
            }

            const cookieName = this.props.merge ? 'merge_autocomplete' : `${this.name}_autocomplete`
            setItemInLocalStorage(cookieName.replace(/[\=&]+/g, ''), JSON.stringify(recents));

            this.call();
        }
    }
    unselectAll():void {
        (<HTMLInputElement>this.element).value = "";
         this.autocompleteinput.value = "";
         this.innerInput.value = "";
         this.element.dispatchEvent(new CustomEvent('change'))
    }

    clear () {
        (<HTMLInputElement> this.element).value = "";
        this.autocompleteinput.value = "";
        this.innerInput.value = "";

        if(this.inTunnel) {
            if(this.element.getAttribute('name') == "l" && document.querySelector('.distance')) {
                document.querySelector('.distance').classList.remove('show');
            }

            if(window.innerWidth < 767 ) {
                (<HTMLElement> document.querySelector('.cta')).style.display = "block";
                if(document.querySelector('[data-facets].side')) {
                    // => serp (cta slecteur différent !!)
                    if(document.querySelector('.tunnel [data-reload]')) {
                        (<HTMLElement> document.querySelector('.tunnel [data-reload]')).style.display = "block";
                    }
                }
                //si on est pas dans le tunnel mobile le clic sur la croix vide les valeurs champs quoi, où et contrat
                if(!(<HTMLInputElement> document.getElementById('engineonboarding')).checked) {
                    (<HTMLInputElement> document.querySelector('[name="l"]')).value = "";
                    (<HTMLInputElement> document.querySelector('[name="c"]')).value = "";
                }
            }
        }
        this.element.dispatchEvent(new CustomEvent("change"));
        this.innerInput.dispatchEvent(new CustomEvent("change"));
    }

    blurIt (event:MouseEvent) {
        // filter the action only on the focused autocomplete to avoid side effects
        if (this.focused) {
            if (this.forceNoBlur) {
                this.forceNoBlur = false;
            } else {
                let blurRect = {top : 0, left : 0, bottom : 0, right : 0};
                let buttonOffset = getOffset(this.placeHolder);
                blurRect.top = buttonOffset.top;
                blurRect.left = buttonOffset.left;
                blurRect.right = blurRect.left + this.placeHolder.offsetWidth;
                blurRect.bottom = blurRect.top + this.placeHolder.offsetHeight;


                if (!(event.x > blurRect.left && event.x < blurRect.right && event.y > blurRect.top && event.y < blurRect.bottom)) {
                    //opened
                    if (this.choices.firstChild) {
                        blurRect = {top : 0, left : 0, bottom : 0, right : 0};
                        buttonOffset = getOffset(this.choices);
                        blurRect.top = buttonOffset.top;
                        blurRect.left = buttonOffset.left;
                        blurRect.right = blurRect.left + this.choices.offsetWidth;
                        blurRect.bottom = blurRect.top + this.choices.offsetHeight;


                        if (!(event.x > blurRect.left && event.x < blurRect.right && event.y > blurRect.top && event.y < blurRect.bottom)) {
                            while(this.choices.firstChild) {
                                this.choices.removeChild(this.choices.firstChild);
                            }
                            this.focused = false;
                            (<HTMLElement> this.element.parentNode).classList.remove('activ');
                            this.wrapperInput.classList.remove("focused");

                            this.innerInput.dispatchEvent(new Event('blur'));
                            //show cta in tunnel mobile
                            if(this.inTunnel && window.innerWidth < 767) {
                                (<HTMLElement> document.querySelector('.cta')).style.display = "block";
                                if(document.querySelector('[data-facets].side')) {
                                    // => serp (cta slecteur différent !!)
                                    if(document.querySelector('.tunnel [data-reload]')) {
                                        (<HTMLElement> document.querySelector('.tunnel [data-reload]')).style.display = "block";
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    toggleBind () {
        if ((<HTMLInputElement> this.element).value == "") {
            this.autocompleteinput.value = "";
            this.innerInput.value = "";
        }
    }

    // Forces the controller to display the error message or not
    // Is dirty, but still better than accessing the fields of the object directly
    public forceValidity(validity: boolean): void {
        this.mandatory = true;
        this.valid = validity;
        this.check();
        this.mandatory = !validity;
    }

    public isValid(): boolean {
        return this.valid;
    }

    check () {
        let valid = true;

        if (this.mandatory) {
            valid = this.valid;

            if (!valid && this.mandatoryMessage) {
                this.element.classList.remove("valid");
                this.element.classList.add("error");
                this.mandatoryMessage.classList.remove("valid");
                this.mandatoryMessage.classList.add("error");
                if (typeof this.errorMessage === 'string') {
                    this.mandatoryMessage.innerText = this.errorMessage;
                }
            } else {
                this.element.classList.remove("error");
                this.element.classList.add("valid");
                if (this.mandatoryMessage) {
                    this.mandatoryMessage.classList.remove("error");
                    this.mandatoryMessage.classList.add("valid");
                    this.mandatoryMessage.innerText = "";
                }
            }
        }

        return valid;
    }

    getCriterionFormatValues(): Array<AutocompleteField> {
        let results: Array<AutocompleteField> = [];

        if (this.belowUl) {
            results = Array.from(this.belowUl.querySelectorAll("li")).map((li: HTMLLIElement) => {
                return {
                    label: li.querySelector("span").innerText,
                    uri: li.querySelector("input").getAttribute("value")
                };
            })
        }
    
        return results;
      }
}